<template>
  <div>
    <v-select
      v-model="value"
      :label="label === null ? field.name : label"
      :items="items"
      :item-text="field.optionText ? field.optionText : 'name'"
      :item-value="field.optionValue ? field.optionValue : 'id'"
      :loading="api.isLoading"
      :rules="rules"
      :disabled="disabled"
      :outlined="outlined"
      :dense="dense"
      :hide-details="hideDetails"
    />

    <v-text-field
      v-model="form.data[field.optionTextSaveAs]"
      :label="label === null ? field.name : label"
      v-if="isShow"
      :outlined="outlined"
      :dense="dense"
      :hide-details="hideDetails"
    />

  </div>

  </template>
  
  <script>
  //BOC:[api]
  import Api from "@/objects/api";
  //EOC
  //BOC:[model]
  import Model from "@/objects/model";
  //EOC
  //BOC:[service]
  import Service from "@/objects/service";
  //EOC
  import { mapState } from "vuex";
  export default {
    components: {
      //
    },
    computed: {
      ...mapState({
        //
      }),
    },
    props: {
      field: {
        type: Object,
      },
      rules: {
        type: Array,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      form: {
        type: Object,
      },
      /**
       * Label override. An empty string is a valid value and means "render no
       * label" — BreadModelForm draws its own above the box, so Vuetify's
       * floating one would be a second copy of the same word.
       */
      label: {
        type: String,
        default: null,
      },
      /**
       * Field chrome, off by default so the add / child-add forms that have
       * always rendered an underline select are untouched. A host laying these
       * out beside outlined inputs passes them so the row lines up: an
       * underline v-select carries 16px of label space above its slot and a
       * details slot below it, which is what pushed the select 16px down and
       * made its column 30px taller than the text fields next to it.
       */
      outlined: {
        type: Boolean,
        default: false,
      },
      dense: {
        type: Boolean,
        default: false,
      },
      hideDetails: {
        type: [Boolean, String],
        default: false,
      },
    },
    watch: {
      value(newValue) {
        if(this.field.optionTextSaveAs){
            let modelValue = newValue;
            let optionTextValue = this.items.find(item => item[this.field.optionValue] === modelValue);
            // A cleared selection, or one whose option isn't in the list, has no
            // text to mirror — indexing into it here threw and took the emit
            // below down with it.
            if (optionTextValue) {
              this.form.setDataProperty(this.field.optionTextSaveAs, optionTextValue[this.field.optionText]);
            }
        }
        this.$emit("input", newValue);
      },
    },
    data: () => ({
      //BOC:[api]
      api: new Api(),
      //EOC
      //BOC:[model]
      model: new Model(),
      //EOC
      //BOC:[service]
      service: new Service(),
      //EOC
      //BOC:[select]
      items: [],
      //EOC
      value:null,
      isShow: false,
    }),
    created() {
      //BOC:[model]
      this.model.getByKey(this.field.modelKey);
      //EOC
      //BOC:[service]
      if(this.model.serviceKey) this.service.set("key",this.model.serviceKey);
      //EOC
      //BOC:[api]
      if(this.field.apiListUrl) {
        this.api.setUrl(
        `${this.$service[this.service.key]}${this.field.apiListUrl}`
      );
      }else{
        this.api.setUrl(
        `${this.$service[this.service.key]}/v1/en/console/tabulator/model/${this.field.modelKey}/upsert/dropdown`
      );
      }
      
      this.api.setCallbackCompleted((response) => {
        this.items = response.data;
        //BOC: preselect the record's current value
        /**
         * Two things this used to get wrong, both visible on an edit form:
         *
         *   1. It read the RELATION OBJECT (`data.InternalDepartment`) straight
         *      into `value`, but the v-select's item-value is a scalar column
         *      (`slug`), so the field rendered blank on a record that had one.
         *   2. It then did `this.value[optionValue]` unguarded. On an add form
         *      `form.data` is `{}` — truthy, but with no relation on it — so
         *      that threw a TypeError inside the promise and silently aborted
         *      the rest of the callback.
         *
         * Both are handled by resolving the scalar first and only then
         * assigning. The relation object is preferred; a record that carries
         * only the plain foreign-key column still preselects correctly.
         */
        const data = this.form.data || {};
        const prop = `${this.field.modelKey}${this.$_ucfirst(this.field.optionValue)}`;
        const relation = data[this.$_ucfirst(this.field.modelKey)];

        let selected = null;
        if (relation && typeof relation === "object") {
          selected = relation[this.field.optionValue];
        } else if (data[prop] !== undefined && data[prop] !== null) {
          selected = data[prop];
        }

        if (selected !== null && selected !== undefined) {
          // Assigning `value` fires the watcher, which emits the scalar to the
          // form — so the 100ms setTimeout this used to need is gone with it.
          this.value = selected;
          this.form.setDataProperty(prop, selected);
        }
        //EOC
      });
      //EOC
      //BOC
      this.api.fetch();
      //EOC
    },
    mounted() {
      //
    },
    methods: {
      //
    },
  };
  </script>